import { render, staticRenderFns } from "./CommonList.vue?vue&type=template&id=87d950f8&"
import script from "./CommonList.vue?vue&type=script&lang=js&"
export * from "./CommonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports